import { render } from "./ReconnectBtn.vue?vue&type=template&id=34d19772&ts=true"
import script from "./ReconnectBtn.vue?vue&type=script&lang=ts"
export * from "./ReconnectBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__